import React from "react"


import Link from "next/link"
import { Button } from "../ui/button"

interface Props {
  title: string
  url: string
  btnText?: string
}

function HeaderTitle({ title, url, btnText,  }: Props) {
  return (
    <div className={` mb-6 md:mb-10 lg:mb-16 ${url? "flex items-center justify-between": ""}`}>
      <h1 className={`text-foreground text-lg md:text-xl lg:text-2xl font-bold
         ${url ? "text-left" : "text-center"}`}>
        {title}
      </h1>
      {url && (
        <Link rel="preload"  prefetch href={url}>
        <Button
          variant={"link"}
          className="   cursor-pointer text-sm "
        >
          {btnText}
        </Button>
      </Link>
      )}
    </div>
  )
}

export default HeaderTitle
